import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import tr from "vuetify/es5/locale/tr";

Vue.use(Vuetify);

export default new Vuetify({
  options: {
    customProperties: true
  },
  theme: {
    // dark: true,
    themes: {
      light: {
        primary: "#252525", // #E53935
        secondary: "#7000FF", // #FFCDD2
        accent: colors.indigo.base // #3F51B5
      },
      dark: {
        primary: "#252525", // #E53935
        secondary: "#ffffff", // #FFCDD2
        accent: "#ffffff", // #3F51B5
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  },
  icons: {
    iconfont: "mdiSvg" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  lang: {
    locales: { tr },
    current: "tr"
  }
});
